import { useLingui } from '@lingui/react/macro';
import { loadingChunkRetry } from '@sit/client-shared';
import { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import DashboardContainer from '../DashboardContainer';
import { TimesheetModals } from './components/TimesheetModals';
import { TimesheetModalsProvider } from './components/TimesheetModalsProvider';

const Timesheets = lazy(() => loadingChunkRetry(() => import('./Timesheets')));

const TimesheetsContainer = () => {
  const { t } = useLingui();
  return (
    <DashboardContainer showSecondaryNav>
      <Helmet>
        <title>{t`Timesheets | Sage Intelligent Time`}</title>
      </Helmet>
      <TimesheetModalsProvider>
        <Suspense fallback={null}>
          <TimesheetModals />
          <Timesheets />
        </Suspense>
      </TimesheetModalsProvider>
    </DashboardContainer>
  );
};

export default TimesheetsContainer;
